/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbFormateurAgrementGridDto } from './FcbFormateurAgrementGridDto';
import {
    FcbFormateurAgrementGridDtoFromJSON,
    FcbFormateurAgrementGridDtoFromJSONTyped,
    FcbFormateurAgrementGridDtoToJSON,
} from './FcbFormateurAgrementGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbFormateurAgrementGridDtoPaginatedResults
 */
export interface FcbFormateurAgrementGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbFormateurAgrementGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbFormateurAgrementGridDto>}
     * @memberof FcbFormateurAgrementGridDtoPaginatedResults
     */
    results?: Array<FcbFormateurAgrementGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbFormateurAgrementGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbFormateurAgrementGridDtoPaginatedResults interface.
 */
export function instanceOfFcbFormateurAgrementGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbFormateurAgrementGridDtoPaginatedResultsFromJSON(json: any): FcbFormateurAgrementGridDtoPaginatedResults {
    return FcbFormateurAgrementGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbFormateurAgrementGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbFormateurAgrementGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbFormateurAgrementGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbFormateurAgrementGridDtoPaginatedResultsToJSON(value?: FcbFormateurAgrementGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbFormateurAgrementGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

